const merge = require("lodash/merge"); // tslint:disable-line

import { Injectable } from "@angular/core";

export const CHART_HISTORIC_COLOUR = "#2078b3";
export const CHART_FORECAST_COLOUR = "#008800";
export const CHART_CAP_COLOUR = "#ffa200";
export const CHART_EXPECTATION_COLOUR = "#ff0000";
export const CHART_FLEXED_COLOUR = "#000000";
export const CHART_INDUSTRY_COLOUR = "#5CB3FF";
export const CHART_FLEXED_MARKER = "square";

interface ChartOptions {
  chart: any;
  title: string;
  legend: any;
  xAxis: any;
  yAxis: any;
  tooltip: any;
  series: any[];
  exporting: any;
  credits: any;
}
@Injectable()
export abstract class ChartOptionsProvider {
  protected defaultChartOptions: ChartOptions = {
    chart: {
      plotBackgroundColor: "#fdfdfd",
      backgroundColor: "#ffffff",
      height: "67%",
      spacingTop: 10,
      spacingBottom: 100,
    },

    exporting: {
      enabled: false,
      chartOptions: {
        // specific options for the exported image
        plotOptions: {
          series: {
            // dataLabels: {
            //   enabled: true,
            //   format: "{y:.2f}%"
            // }
          },
        },
        title: {
          text: "No Data",
        },
      },
      buttons: {
        contextButton: {
          y: -24,
        },
      },
      fallbackToExportServer: false,
      sourceWidth: 450,
      sourceHeight: 325,
      // scale: 1
    },
    title: "No Data",
    legend: {
      floating: true,
      y: 35,
      itemStyle: {
        fontSize: "11px",
      },
      itemDistance: 10,
    },
    xAxis: {
      gridLineWidth: 1,
      tickmarkPlacement: "on",
    },
    yAxis: {
      min: 0,
      allowDecimals: false,
      labels: {
        step: 1,
      },
    },
    tooltip: {
      pointFormat: "{series.name}: {point.y:.2f}%",
    },
    series: [
      {
        color: CHART_HISTORIC_COLOUR,
        pointWidth: 20,
        marker: {
          symbol: "circle",
          enabled: true,
        },
        visible: false,
        data: [],
      },
      {
        color: CHART_FORECAST_COLOUR,
        pointWidth: 20,
        marker: {
          symbol: "circle",
        },
        visible: false,
        data: [],
      },
      {
        color: CHART_CAP_COLOUR,
        pointWidth: 20,
        marker: {
          symbol: "circle",
        },
        visible: false,
        data: [],
      },
      {
        color: CHART_EXPECTATION_COLOUR,
        pointWidth: 20,
        marker: {
          symbol: "circle",
        },
        visible: false,
        data: [],
      },
      {
        color: CHART_FLEXED_COLOUR,
        pointWidth: 20,
        marker: {
          symbol: "circle",
          enabled: true,
        },
        visible: false,
        data: [],
      },
    ],
    credits: {
      href: false,
      enabled: false,
    },
  };

  constructor() {}

  /**
   * getOptions
   */
  public getOptions(company, chartOptions) {
    if (!company) return chartOptions;
    chartOptions = chartOptions || {};
    chartOptions = merge({}, this.defaultChartOptions, chartOptions);
    chartOptions.series = chartOptions.series.filter(
      (item) => item.data.length > 0
    );
    chartOptions.exporting.chartOptions.title.text = chartOptions.title;
    return chartOptions;
  }

  setYMax(chartOptions, maxVal = 0) {
    const maxValues = chartOptions.series.map((series) =>
      Math.max(
        ...series.data.map((data) => {
          if (data) return data[1] || null;
        })
      )
    );
    chartOptions.yAxis.max =
      Math.max(maxVal, ...maxValues.filter((val) => val !== undefined)) + 2;
    return chartOptions;
  }
  setYMin(chartOptions, minVal = 0) {
    const minValues = chartOptions.series.map((series) =>
      Math.min(
        ...series.data.map((data) => {
          if (data) return data[1] || null;
        })
      )
    );
    const lowestValue = Math.min(
      ...minValues.filter((val) => val !== undefined)
    );
    chartOptions.yAxis.min = Math.min(
      minVal,
      lowestValue === 0 ? 0 : lowestValue - 2
    );
    return chartOptions;
  }
}



// WEBPACK FOOTER //
// ./src/providers/chart-options/chart-options.ts